//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import makeDebug from 'debug'
import { mapGetters, mapActions, mapState } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'
import {
  ACTION_INCREMENT_NEWSLETTER_COUNTER,
  ACTION_LOAD_MINICART,
  ACTION_LOAD_MINIWISHLIST,
} from '@/scripts/store/actions'

import wcs from '@/scripts/libs/wcs'
import { Cookies } from '@/scripts/libs/cookies'
import { WcsNewsletter } from '@/scripts/libs/wcs/newsletter'
import { TABLET, MOBILE } from '@/scripts/constants/media-query'
import md5 from 'md5'
import { TRACKER_SUBMIT_NEWSLETTER } from '@/scripts/constants/tracker'
import { ALREADY_SIGNED } from '@/scripts/constants/cookies'
import { WcsEarlyAccess } from '@/scripts/libs/wcs/early-access'
import { EarlyAccess } from '@/scripts/libs/early-access'
import { NewsletterOverlayType } from '@/scripts/constants/newsletter-modal'
import { USER_CLUSTER, EARLY_ACCESS_COOKIE } from '@/scripts/constants/early-access'
import sha from 'sha.js'

import RbNewsletterModalContentSuccessForm from '@/elements/newsletter-modal/newsletter-modal-content-success-form.vue'

const debug = makeDebug('common:newsletterModal')
export default {
  name: 'rb-newsletter-modal-content',
  components: {
    RbNewsletterModalContentSuccessForm,
  },
  props: {
    setNeedsReloadStatus: {
      type: Function,
      default: () => ({}),
    },
  },
  data() {
    return {
      signUpEmail: '',
      errorMessage: '',
      loading: false,
      success: false,
      error: false,
      modalRightContentClasses:
        'col-12 col-lg-7 rb-editorial__txt-color--white rb-newsletter-modal-content__right',
    }
  },
  computed: {
    ...mapGetters(['translation']),
    ...mapState({
      orderId: (state) => state.sidebar.cart.details.orderId,
    }),
    canShowAdditionalField() {
      const { newsletterOverlayType } = wcs.getStoreConfig()
      return newsletterOverlayType === NewsletterOverlayType.ADDITIONAL_FIELDS
    },
    loaderDimensionCSSVariables() {
      return {
        '--loaderHeight': `${this.loaderHeigthCSSVariable}px`,
        '--loaderWidth': `${this.loaderWidthCSSVariable}px`,
      }
    },
    loaderHeigthCSSVariable() {
      return this.$refs.modalRightContent?.clientHeight
    },
    loaderWidthCSSVariable() {
      return this.$refs.modalRightContent?.clientWidth
    },
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
  },
  validations: {
    signUpEmail: {
      required,
      email,
    },
  },
  methods: {
    ...mapActions({
      incrementNewsletterCounter: ACTION_INCREMENT_NEWSLETTER_COUNTER,
      loadCart: ACTION_LOAD_MINICART,
      loadMiniWishlist: ACTION_LOAD_MINIWISHLIST,
    }),
    async submitNewsletterModalForm() {
      this.$v.$touch()
      this.error = false
      if (!this.$v.invalid && this.signUpEmail) {
        this.loading = true
        const response = await WcsNewsletter.submitNewsletterRegistration(this.signUpEmail)
        this.stateForm = response.stateForm
        debug(this.stateForm)
        this.success = true
        Cookies.set(ALREADY_SIGNED, true)
        const { earlyAccess } = wcs.getStoreConfig()
        if (earlyAccess.active) {
          sessionStorage.setItem('promoCodeToApplyEvaluateQuery', 'eaccess')
          Cookies.set(USER_CLUSTER, EARLY_ACCESS_COOKIE)
          this.incrementNewsletterCounter()
          EarlyAccess.checkAndWriteEarlyAccessCookie()
          await WcsEarlyAccess.callEarlyAccess(this.orderId, async () => {
            await this.loadCart()
            await this.loadMiniWishlist()
            EarlyAccess.checkAndEmitEventForRoxLensPanel()
          })
          this.setNeedsReloadStatus(true)
        }
        this.$ma.trackEvent({
          event: TRACKER_SUBMIT_NEWSLETTER,
          value: {
            User_Email_MD5: md5(this.signUpEmail.toLowerCase()),
            User_Email_SHA256: sha('sha256').update(this.signUpEmail.toLowerCase()).digest('hex'),
            User_EmailOptin: '1',
          },
        })
        this.loading = false
      }
    },
    emitCloseNewsletterModal() {
      this.$emit('closeNewsletterModal')
    },
  },
}
